'use client';

import { ReactNode } from 'react';

import Modal from '@/components/Modal';
import { useOnceWhileOpen } from '@/hooks/useOnceWhileOpen';
import Paper from '@/components/Paper';
import { cn } from '@/utils/twx';

import Button from '../Button';

interface ConfirmAlertProps {
  isOpen: boolean;
  close: () => void;
  title: ReactNode;
  subTitle?: ReactNode;
  extra?: ReactNode;
  cancelText?: string;
  confirmText?: string;
  allowOutsideClickClose?: boolean;
  allowEscClose?: boolean;
  backgroundClassName?: string;
  buttonWrapperClassName?: string;
  /** 확인 버튼 색. 기본 gray, 판매 상태 변경처럼 주황 강조가 필요하면 orange */
  confirmColor?: 'gray' | 'orange';
  onClickConfirm?: () => void;
  onClickCancel?: () => void;
}

const ConfirmAlertV2 = ({
  isOpen,
  close,
  confirmText = '확인',
  cancelText = '취소',
  title = '',
  subTitle = '',
  extra = '',
  backgroundClassName = '',
  onClickConfirm,
  onClickCancel,
  allowEscClose = true,
  allowOutsideClickClose = true,
  buttonWrapperClassName = '',
  confirmColor = 'gray',
}: ConfirmAlertProps) => {
  const handleClose = () => {
    close();
  };

  const handleCancel = () => {
    if (onClickCancel) onClickCancel();
    close();
  };

  const claimConfirm = useOnceWhileOpen(isOpen);

  const handleConfirm = () => {
    if (!claimConfirm()) return;

    if (onClickConfirm) onClickConfirm();
    close();
  };
  return (
    <Modal
      isOpen={isOpen}
      close={handleClose}
      allowOutsideClickClose={allowOutsideClickClose}
      allowEscClose={allowEscClose}
    >
      <Paper
        className={cn(
          'min-w-[343px] rounded-[30px] w-[343px] break-keep *:text-balance',
          !!extra && 'bg-[#F7F7F7]',
          backgroundClassName,
        )}
      >
        <div className="text-[18px] font-semibold text-center">{title}</div>
        {!!subTitle && <div className="mt-2.5 text-[14px] text-gray-2 text-center">{subTitle}</div>}
        {!!extra && extra}
        <div className={cn('mt-7 flex justify-center gap-2.5', buttonWrapperClassName)}>
          <Button
            variant={'tonalgray'}
            onClick={handleCancel}
            className="w-[136px] bg-gray-7"
            size="sm"
          >
            {cancelText}
          </Button>
          <Button
            variant={confirmColor === 'orange' ? 'primary' : 'gray'}
            onClick={handleConfirm}
            className="w-[136px] font-semibold"
            size="sm"
          >
            {confirmText}
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};

export default ConfirmAlertV2;
